export default "__VITE_ASSET__CCXhlcbG__"